import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import { cn } from '@ui/lib/utils.js';

export { default as PAlert } from './PAlert.vue';
export { default as PAlertDescription } from './PAlertDescription.vue';
export { default as PAlertTitle } from './PAlertTitle.vue';
export { default as PAlertAction } from './PAlertAction.vue';

const pAlertCvaConfig = {
    variants: {
        variant: {
            default: 'bg-card-primary text-foreground-primary',
            destructive:
                'text-foreground-destructive bg-card-primary [&>svg]:text-current *:data-[slot=alert-description]:text-foreground-destructive/90',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
} as const;
export const alertVariants = cva(
    cn(
        'relative',
        'w-full',
        'rounded-lg',
        'border',
        'border-border-default',
        'px-4',
        'py-3',
        'text-sm',
        'grid',
        'grid-rows-[auto_auto]',
        'grid-cols-[0_1fr]',
        'has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr]',
        'has-[[data-slot=alert-action]]:grid-cols-[0_1fr_auto]',
        'has-[>svg]:has-[[data-slot=alert-action]]:grid-cols-[calc(var(--spacing)*4)_1fr_auto]',
        'gap-x-3',
        'gap-y-0.5',
        'items-center',
        '[&>svg]:size-4',
        '[&>svg]:text-current',
    ),
    pAlertCvaConfig,
);

export type AlertVariants = VariantProps<typeof alertVariants>;

export const P_ALERT_VARIANTS = Object.keys(pAlertCvaConfig.variants.variant);
export type PAlertVariant = keyof typeof pAlertCvaConfig.variants.variant;
